import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';

import AttachFileIcon from '@/svg-icons/attachments';

const MediasSection = ({ medias }) => {
  if (!medias || medias.length === 0) return null;

  return (
    <div className="w-full">
      <div className="font-bold text-[calc(6px+0.4vw)] my-[0.6vw] flex items-center">
        <AttachFileIcon viewBox="0 0 34.016 34.016" className="text-gray-700 mr-2 w-6 h-6 shrink-0" />
        <FormattedMessage id="medias" />
      </div>
      
      {medias.map(media => (
        <div 
          className="flex flex-wrap text-[#858585] text-[calc(6px+0.4vw)] my-[1vw] pl-[calc(14px+1.8vw)]" 
          key={media.external_id}
        >
          <div className="w-1/4" data-cy="order-details-media-type">
            <div className="font-bold">
              <FormattedMessage id="type" />
            </div>
            <FormattedMessage id={media.type} />
          </div>

          <div className="w-1/4" data-cy="order-details-media-external-id">
            <div className="font-bold">
              <FormattedMessage id="external_id" />
            </div>
            {media.external_id}
          </div>

          <div className="w-1/2" data-cy="order-details-media-external-uri">
            <div className="font-bold">
              <FormattedMessage id="external_uri" />
            </div>
            <div className="block max-w-full overflow-hidden text-ellipsis whitespace-nowrap">
              <a 
                href={media.external_uri} 
                target="_blank" 
                rel="noreferrer noopener"
                className="text-[#007BFF] hover:text-[#0056b3] hover:underline"
              >
                {media.external_uri}
              </a>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

MediasSection.propTypes = {
  medias: PropTypes.array,
};

MediasSection.defaultProps = {
  medias: [],
};

export default MediasSection;
